<template>
  <div>
    <div class="management_top_box">
      <h4>
        <slot name="title"> </slot>
      </h4>
    </div>
    <div class="d-flex justify-content-end w-100">
      <slot name="excel"> </slot>
    </div>
    <div>
      <table class="mgt_tbl">
        <tbody>
          <slot name="filter"> </slot>
        </tbody>
      </table>
    </div>

    <div class="sub_chart_box">
      <!-- 차트 영역 -->
      <!--      <img src="./img/chart_img01.png" />-->
      <slot name="graph"> </slot>
    </div>

    <slot name="paging"> </slot>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style>
.selectInput {
  width: 175px;
}
</style>
